import { useLocation } from "react-router-dom";

export const useLocationMatch = () => {
  const { pathname } = useLocation();
  const cabinetLocationMatch = pathname === "/cabinet";
  const authLocationMatch = pathname === "/auth";
  const signupLocationMatch = pathname === "/signup";
  const paymentLocationMatch = pathname === "/payment";
  const paymentsInfoLocationMatch = pathname === "/payments-info";
  const mediationLocationMatch = pathname === "/mediation";

  return {
    cabinetLocationMatch,
    authLocationMatch,
    signupLocationMatch,
    paymentLocationMatch,
    paymentsInfoLocationMatch,
    mediationLocationMatch,
  };
};
